<template>
  <div>
    <section class="feature-area section-padding2 toubugaodu"
      style=" height: 400px; background: url('../static/assets/images/bannerc.jpg') no-repeat;background-size: 100% auto;">
      <div class="container">
        <div class="row toubugaoduzt" style="height: 400px; line-height: 400px;color: #ffffff;font-size: 45px;">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <p style=" font-style: initial; ">关于我们</p>
            </div>
          </div>
        </div>

      </div>
      <div class="about_tab">
        <router-link class="about_tab_jj" to="/about" @click.native="reloadPage">企业简介</router-link>
        <router-link class="about_tab_wh" to="/wenhua" @click.native="reloadPage">企业文化</router-link>
        <router-link class="about_tab_jg" to="/jiagou" @click.native="reloadPage"
          style="background: #0473db;color: #ffffff;">企业架构</router-link>
        <router-link class="about_tab_zr" to="/zeren" @click.native="reloadPage">认证体系</router-link>
        <router-link class="about_tab_sm" to="/shengming" @click.native="reloadPage">版权声明</router-link>
      </div>
    </section>
    <section class="feature-area section-padding2 jiagou_section1">
      <div class="container jiagouimg" style="padding-top: 100px; padding-bottom: 100px;">
        <p class="wow zoomIn animated" v-html="aboutinfo.content"></p>

        <img :src="newurl + aboutinfo.pics" class="pc_201411 wow zoomIn animated" />
        <img :src="newurl + aboutinfo.enclosure" class="wap_201411 wow zoomIn animated" />
      </div>
    </section>
    <!-- Feature Area End -->


  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/23', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },


  }
};
</script>



// WEBPACK FOOTER //
// Jiagou.vue?a2cecd86